import _find from 'lodash/find';
import _includes from 'lodash/includes';

export function getLocationProp(obj = {}, props) {
  if (typeof obj === 'string') return obj;
  return _find(obj, (v, k) => _includes(props, k)) || obj.value;
}
